import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import {
  BAR_GRID_TOP,
  BAR_GRID_BOTTOM_WITH_RICH_IMG,
  LEGEND_BOTTOM,
} from '@/pages/intelligence/pages/TopCharts/_config/echarts';

export const STATIC_BAR_CHART_OPTION = {
  color: ECHARTSCOLOR,
  grid: {
    left: '30px',
    right: '0px',
    top: BAR_GRID_TOP,
    bottom: BAR_GRID_BOTTOM_WITH_RICH_IMG - 4,
    containLabel: true,
  },
  tooltip: {
    trigger: 'axis',
    triggerOn: 'mousemove',
    padding: 0,
    confine: true,
    showDelay: 0, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
    hideDelay: 200,
    borderWidth: 0,
    // backgroundColor: '#262832F2',
    backgroundColor: 'rgba(0,0,0,0)',
    axisPointer: {
      type: 'shadow',
      label: {
        backgroundColor: '#6a7985',
      },
      shadowStyle: {
        color: '#96c5eb',
        opacity: '0.05',
        width: 'auto',
      },
    },
    lineStyle: {
      color: 'rgba(0,0,0,0.25)',
      width: 2,
      type: 'solid',
    },
    textStyle: {
      color: '#FFFFFF',
      fontSize: 12,
    },
  },
  legend: {
    type: 'scroll',
    orient: 'horizontal', // 横向
    pageIconColor: '#000', // 翻页箭头颜色
    selectedMode: true,
    pageIconSize: 12,
    pageTextStyle: {
      color: '#000', // 翻页数字颜色
    }, // 翻页数字设置
    show: true,
    icon: 'circle',
    itemWidth: 8,
    itemHeight: 8,
    borderWidth: 0,
    bottom: LEGEND_BOTTOM,
    inactiveBorderWidth: 0,
    inactiveBorderColor: '#ffffff', // 默认存在#ccc，看起来会比设置的icon图例大小有区别
    inactiveColor: '#ccc', // 关闭时图例颜色
    left: 'center',
    textStyle: {
      color: '#888888',
      fontSize: 12,
    },
    itemGap: 20, // 图例之间间距20
  },
  xAxis: {
    type: 'category',
    boundaryGap: true,
    rotate: 30,
    fontSize: 12,
    axisTick: {
      alignWithLabel: true, // x轴刻度线与标签对齐
      lineStyle: {
        color: '#BFBFBF',
        // 透明度会展示到虚线，暂时用纯色代替
        // color: '#000',
        // opacity: 0.25,
        width: 1,
      },
    },
    axisLabel: {
      margin: 20,
      align: 'center',
      interval: 0,
      overflow: 'truncate',
      ellipsis: '...',
      fontSize: 12,
      // color: '#000',
      // opacity: 0.45,
      color: '#838697',
    },
    axisLine: {
      show: true,
      // onZero: false,//当y轴有负数时,让x轴下落在y轴最小值
      lineStyle: {
        color: '#BFBFBF',
        width: 1,
      },
    },
    data: [],
  },
  yAxis: {
    type: 'value',
    splitLine: {
      lineStyle: {
        type: 'dashed',
        color: '#E5E5E5',
      },
    },
    axisLabel: {
      color: '#838697',
      fontSize: 12,
      opacity: 0.45,
      formatter: (payload: number) => payload,
    },
  },
  series: [],
  dataset: {
    dimension: [],
    source: [],
  },
};
